import './slider.css';
import { wrapper, navigation } from './templates.templ';

export default class Slider  {

  constructor(el, customclasses = '', els = 'li', options) {
    this.el = el;
    this.els = els;
    this.list = [];
    this.index = 0;
    this.customclasses = customclasses;
    this.options = options || {};
    this.render();
    if (this.options.timer) {
      this.startTimer();
    } else {
      this.changeSlide();
    }
    return this.el;
  }

  onClick(e, i) {
    clearInterval(this.timer);
    this.index = i;
    this.changeSlide();
  }

  startTimer() {
    this.timer = setInterval(()=> {
      this.index = this.index > this.list.length - 2 ? 0 : this.index + 1;
      this.changeSlide();
    }, 5000);
  }

  onArrow(e, type) {
    clearInterval(this.timer);
    if (type === 'left') {
      this.index = this.index < 1 ? this.list.length - 1 : this.index - 1;
    } else {
      this.index = this.index > this.list.length - 2 ? 0 : this.index + 1;
    }
    this.changeSlide();
  }

  setToActive(li, i) {
    
    li.className = li.className.replace(/active/g, '');
    if (i === this.index) {
      var cl = li.className.split(' ');
      cl.push('active');
      li.className = cl.join(' ');
    }
  }

  changeSlide() {
    const { dotts, legend } = this.options;
    const sliders = this.el.querySelectorAll(`.slider_comp ${this.els}`);
    var i = 0;

    if (dotts) {
      let i = 0;
      const navList = this.el.querySelectorAll('.slider_nav_widget_list li');
      while(i < navList.length) {
        this.setToActive(navList[i], i);
        i += 1;
      }
    }
    if (legend) {
      const legend = this.el.querySelector('.slide_widget_legend');
      const txt = document.createTextNode(`${this.index + 1}/${sliders.length}`);
      while (legend.firstChild) {
          legend.removeChild(legend.firstChild);
      }
      legend.appendChild(txt);
    }
    i = 0;
    while(i < sliders.length) {
      this.setToActive(sliders[i], i);
      i += 1;
    }
  }

  render() {
    wrapper(this);
    const nav = navigation(this, this.els);
    if (!nav) {
      return;
    }
    const { slider, slides } = nav;
    this.el = slider;
    this.list = slides;
  }
}



// WEBPACK FOOTER //
// ./modules/Slider/index.js